import React from "react";

import AuditEventCard from "./AuditEventCard";
import AuditLoadingSkeleton from "./AuditLoadingSkeleton";

export default function AuditHistory({
  vm,
  showRecordRef = false,
  entitySlug,
}) {
  const {
    audits,
    loading,
    loadingMore,
    hasMore,
    loadMore,
    requestRestore,
    restoringAuditId,
  } = vm;

  if (loading) return <AuditLoadingSkeleton />;

  if (audits.length === 0) {
    return (
      <div className="py-14 text-center">
        <p className="text-sm font-medium text-[#64748B]">
          No audit history yet.
        </p>
        <p className="mt-1 text-xs text-[#94A3B8]">
          Changes will appear here once they are recorded.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {audits.map((event) => (
        <AuditEventCard
          key={event.id}
          event={event}
          showRecordRef={showRecordRef}
          entitySlug={entitySlug}
          onRestoreRequest={requestRestore}
          restoringAuditId={restoringAuditId}
        />
      ))}

      {hasMore ? (
        <div className="flex justify-center pt-2">
          <button
            type="button"
            onClick={loadMore}
            disabled={loadingMore}
            className="inline-flex items-center gap-2 rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB] disabled:opacity-50"
          >
            {loadingMore ? "Loading…" : "Load more"}
          </button>
        </div>
      ) : null}
    </div>
  );
}
